<style lang="less">
.double-cell-item {
  min-height: 55px;
}
.double-cell-item > div {
  height: 55px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 28px;
  padding: 12px 5px 0 5px;
}
.double-row-p {
  border-top: 1px solid rgba(209, 143, 0, 0.1);
}
</style>
<script>
import objectUtil from '../../../static/js/objectUtil'
import template from '../../../static/js/template'
export default {
  name: 'doubleRowSurface',
  props: {
    doubleRow: String,
    item: Object,
    rowData: Object,
    componentClassName: null,
    propsCompile: null,
    doubleRowDataKey: String,
    renderComponent: Boolean,
  },
  computed: {
    ourStyle() {
      const item = this.item
      return item.required || (item.validators && item.validators.length > 0)
        ? { paddingTop: 0, display: 'flex', alignItems: 'center' } // #44406 合同档案列表-编辑 如何其他地方有影响，可以看看这里的修改。原值只有 paddingTop: 0
        : null
    },
  },
  methods: {
    createOtherVnode(h, item) {
      const routerQuery = this.$route.query || {}
      const strategy = this.$store.state.strategy.strategy || {}
      const souceData = { row: this.rowData, routerQuery, strategy, otherRow: true }
      const otherValue = item.template
        ? template.render(item.template, souceData) // otherRow 表示是否从行
        : objectUtil.getValueByPath(this.rowData[this.doubleRowDataKey], item.property, '') //处理从行模板数据渲染
      const filterValue = item.parameter
        ? this.$options.filters.formatFilter(otherValue, item.parameter.type, item.parameter.format)
        : otherValue
      let valNode
      if (this.renderComponent) {
        const propsData = Object.assign({}, this.propsCompile, {
          disabled: true,
          value: otherValue,
        })
        valNode = h(this.componentClassName, { props: propsData, style: item.style })
      } else {
        if (typeof otherValue === 'object' && otherValue !== null) {
          const propsData = Object.assign({}, this.propsCompile, {
            disabled: true,
            value: otherValue,
          })
          valNode = h(this.componentClassName, { props: propsData, style: item.style })
        } else {
          valNode = filterValue ? filterValue : filterValue === 0 ? '0' : '-'
        }
      }
      const otherVnode = h(
        'div',
        {
          class: {
            'double-row-p': true,
            'double-row': this.doubleRow === 'all',
          },
          style: template.render(item.style, souceData),
          attrs: {
            title: typeof filterValue !== 'object' ? filterValue : '',
          },
        },
        [valNode]
      )
      return otherVnode
    },
  },
  render(h) {
    const lastVnode = [],
      item = this.item
    // 渲染表格主行
    if (this.doubleRow !== 'other') {
      const ourVnode = h(
        'div',
        {
          style: this.ourStyle,
        },
        this.$slots.default
      )
      lastVnode.push(ourVnode)
    }
    // 渲染表格从行，非对象直接渲染值，对象渲染不可编辑的组件
    if (this.doubleRow !== 'our' && !item.combine) {
      if (this.rowData.hasOwnProperty('master')) {
        if (this.rowData.master) lastVnode.push(this.createOtherVnode(h, item))
      } else {
        lastVnode.push(this.createOtherVnode(h, item))
      }
    }
    // 返回渲染好的表格主行从行
    return h(
      'div',
      {
        class: { 'double-cell-item': this.doubleRow ? true : false },
      },
      lastVnode
    )
  },
}
</script>
